import { render } from "./Integrations.vue?vue&type=template&id=4cfdc210&scoped=true"
import script from "./Integrations.vue?vue&type=script&lang=js"
export * from "./Integrations.vue?vue&type=script&lang=js"

import "./Integrations.vue?vue&type=style&index=0&id=4cfdc210&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cfdc210"]])

export default __exports__